const TIMEOUT_MESSAGE = "Request timed out. Please check your connection and try again.";
const NETWORK_MESSAGE = "Unable to connect to the server. Please check your internet connection and try again.";
const SERVER_MESSAGE = "Server error. Please try again later.";
const NOT_FOUND_MESSAGE = "The requested resource was not found.";
const AUTH_MESSAGE = "You are not authorized to perform this action.";

const getBackendMessage = (error) => {
  const responseData = error?.response?.data;
  const message = typeof responseData?.message === "string"
    ? responseData.message.trim()
    : "";
  const errorMessage = typeof responseData?.error === "string"
    ? responseData.error.trim()
    : "";

  return message || errorMessage;
};

const isTechnicalMessage = (message) => (
  /^Request failed with status code \d+$/i.test(message)
  || /^Network Error$/i.test(message)
  || /^timeout of \d+ms exceeded$/i.test(message)
);

const getApiErrorMessage = (error, fallbackMessage) => {
  const fallback = fallbackMessage || "Something went wrong. Please try again.";
  const status = error?.response?.status;
  const backendMessage = getBackendMessage(error);
  const meaningfulBackendMessage = backendMessage && !isTechnicalMessage(backendMessage)
    ? backendMessage
    : "";

  if (status) {
    if (status === 401 || status === 403) {
      return meaningfulBackendMessage || AUTH_MESSAGE;
    }

    if (status === 404) {
      return meaningfulBackendMessage || NOT_FOUND_MESSAGE;
    }

    if (status >= 500) {
      return meaningfulBackendMessage || SERVER_MESSAGE;
    }

    if (status >= 400) {
      return meaningfulBackendMessage || fallback;
    }

    return fallback;
  }

  const errorCode = error?.code;
  const errorMessage = typeof error?.message === "string" ? error.message : "";
  const isTimeout = errorCode === "ECONNABORTED"
    || errorCode === "ETIMEDOUT"
    || /timeout/i.test(errorMessage);

  if (isTimeout) {
    return TIMEOUT_MESSAGE;
  }

  const isNetworkError = errorCode === "ERR_NETWORK"
    || Boolean(error?.request)
    || /^Network Error$/i.test(errorMessage);

  if (isNetworkError) {
    return NETWORK_MESSAGE;
  }

  return fallback;
};

export default getApiErrorMessage;
